import { markNoShowAppointmentsApi as generatedMarkNoShowAppointmentsApi } from '../generated/appointments/markNoShowAppointments';

const markNoShowAppointmentsApi = generatedMarkNoShowAppointmentsApi.enhanceEndpoints({
  endpoints: {
    markNoShowAppointments: {
      invalidatesTags: [
        { id: 'PENDING', type: 'UpcomingAppointment' as const },
        { id: 'UPCOMING', type: 'UpcomingAll' as const },
        { id: 'UPCOMING', type: 'UpcomingAppointment' as const },
        { type: 'Schedule' as const },
        { type: 'Slots' as const },
      ],
    },
  },
});

export const { useMarkNoShowAppointmentsMutation } = markNoShowAppointmentsApi;
export { markNoShowAppointmentsApi };
